import {connect} from 'react-redux'
import {untouch} from 'redux-form'
import {REGISTRATION_FORM_ID} from '../../constants'
import {NameDispatchProps, NameOwnProps} from './interfaces'
import {Name as Presentation} from './name'

const mapDispatch = dispatch => ({
  untouch: () => dispatch(untouch(REGISTRATION_FORM_ID, 'firstName')),
})

export const Name = connect<null, NameDispatchProps, NameOwnProps>(null, mapDispatch)(Presentation)
